import React, { FC } from 'react'

const SheildPaymentIcon: FC = () => (
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.00002 0C4.54586 0 2.89397 0.621513 1.68975 1.18837C0.901878 1.55925 0.507945 1.74468 0.233953 2.20005C-0.0400386 2.65541 -0.017619 3.11401 0.0272202 4.0312C0.158882 6.72436 0.657368 9.37196 2.28564 11.5465C3.07653 12.6028 4.67841 14 6.00002 14C7.32158 14 8.92345 12.6028 9.71433 11.5466C11.3427 9.37199 11.8412 6.72434 11.9728 4.03114C12.0176 3.11399 12.04 2.65541 11.766 2.20005C11.4921 1.7447 11.0981 1.55926 10.3103 1.1884C9.10606 0.62153 7.45416 0 6.00002 0Z"
      fill="#3B82F6"
    />
  </svg>
)

export default SheildPaymentIcon
